const state = {
	NODE_ENV: null,
	NODE_BUILD: null,
	isMobile: null,
	imgUrl: null,
	adminImgUrl: null,
	gcId: null,
	gClientId: null,
	gcScope: null,
	gaKey: null,
	gaDiscoveryDocs: null,
	adminDomain: null,
	pushNowTerm: null,
	pushReserveTerm: null,
	lambdaApiDomain: null,
	admin2Domain: null,
	adminEcDomain: null,
	IMAGE_STORAGE_PATH: '',
	authDomain: null,
	apiJBaseURL: null,
	cookieDomain: '',
	glowpickDomain: '',
	TINYMCE_API_KEY: '',
};

const mutations = {
	init(state, envs) {
		let value;
		Object.keys(envs).forEach(key => {
			value = envs[key];
			switch (key) {
				case 'NODE_BUILD':
					state[key] = value !== 'false';
					break;
				case 'pushNowTerm':
				case 'pushReserveTerm':
					state[key] = Number(value);
					break;
				case 'cookieDomain':
					if (envs.NODE_BUILD !== 'false') {
						state[key] = value;
					}
					break;
				default:
					state[key] = value;
					break;
			}
		});
	},
};

export default { namespaced: true, state, mutations };
